import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { SwarovskiOptikLocale } from "@swo/shared";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../styles/styles-css-variables";
import { CSS_MQ } from "../../styles/breakpoints";
import { showPrice } from "@swo/shared";
import React from "react";
import { SwarovskiLink } from "../_shared-components/ui-elements/SwarovskiLink";
import { FONTS, fontSize } from "../../styles/fonts";
import { ImageAndProductType, SwarovskiOptikLocaleFrontend } from "@swo/storefront";

export const ImageAndProductProductTeaserInfo: ReactTFC<{
  product: NonNullable<ImageAndProductType["product"]>;
  localeForNumberFormat: SwarovskiOptikLocaleFrontend;
}> = props => {
  const Content = (
    <>
      <span css={productNameStyles}>{props.product.name}</span>
      {props.product.price && (
        <span css={productPriceStyles}>{showPrice(props.product.price, props.localeForNumberFormat)}</span>
      )}
    </>
  );

  return (
    <div
      className={"product-teaser-info"}
      css={css`
        color: ${CSS_COLORS.Green};

        position: relative;

        z-index: 2;
        background-color: ${CSS_COLORS.White};

        padding-top: var(--m);

        ${CSS_MQ.atMostMd} {
          display: inline-block;
        }
      `}
    >
      <span
        css={css`
          text-align: left;
          display: block;

          ${CSS_MQ.atLeastLg} {
            filter: opacity(0.35);
          }

          &:focus,
          &:hover {
            filter: opacity(1);
          }
        `}
      >
        <SwarovskiLink
          link={props.product.link}
          isInternal={true}
          scrollToTop={true}
          styled={"no-decoration"}
          attachStyles={css`
            color: inherit;
            display: block;
          `}
        >
          {Content}
        </SwarovskiLink>
      </span>
    </div>
  );
};

const productNameStyles = [
  FONTS.SwarovskiFutura500,
  fontSize.x2,
  css`
    &::before {
      content: "";

      border-top: 1px solid ${CSS_COLORS.Black};
      width: 25px;
      display: block;
      margin-bottom: 15px;
    }

    display: block;
    margin-bottom: 3px;
  `,
];

const productPriceStyles = [
  FONTS.SwarovskiFutura300,
  fontSize.x2,
  css`
    color: ${CSS_COLORS.Black};
  `,
];
